export default __webpack_public_path__ + "static/media/flash.2e8c0cff.png";